<template>
  <div class="instructions">

    <div class="instructions__message">

      <div class="instructions__icon">
        <ArrivalSvg />
      </div>

      <h2>
        <span>Você está no laboratório?</span>
        <span>Confirme sua chegada apenas se realmente estiver na unidade</span>
      </h2>
    </div>

    <div class="instructions__actions">

      <VButton
        id="unitArrival_instructions_action"
        text="Confirmar chegada"
        @click.native="triggerConfirmArriving"
      />

      <VButton
        id="unitArrival_instructions_action"
        text="Ainda não cheguei"
        @click.native="triggerNotArrivedYet"
      />
    </div>
  </div>
</template>

<script>
import VButton from '@/components/commons/VButton.vue';
export default {
  name: 'UnitArrivalInstructions',
  components: {
    VButton
  },
  methods: {
    triggerConfirmArriving() {
      this.$emit('triggerConfirmArriving', true, false);
    },
    triggerNotArrivedYet() {
      this.$emit('triggerNotArrivedYet', true, true);
    }
  }
};
</script>

<style lang="scss" scoped>
.instructions {
  align-items: center;
  background-color: white;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  width: 100%;

  &__message {
    display: flex;
    flex-direction: column;
    max-width: 355px;
    padding: 16px;
    justify-content: center;
    align-items: center;

    & h2 {
      display: flex;
      flex-direction: column;
      align-items: center;

      & span {
        font-weight: 700;
        font-size: 20px;
        line-height: 25px;

        &:nth-child(2) {
          width: 80%;
          margin-top: 16px;
          font-size: 16px;
          line-height: 23.8px;
          font-weight: 400;
        }
      }
    }
  }

  &__icon {
    background-color: var(--color-primary-lighten-4);
    border-radius: 50%;
    height: 72px;
    margin: 16px 0px;
    position: relative;
    width: 72px;

    & svg {
      bottom: 0;
      left: 0;
      margin: auto;
      max-height: 55px;
      position: absolute;
      right: 0;
      top: 0;

      & path {
        fill: var(--color-primary);
      }
    }
  }

  &__actions {
    border-top: 1px solid var(--color-grey-2);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px;
    width: 100%;

    button {
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;

      &:first-child {
        margin-bottom: 16px;
      }

      &:nth-child(2) {
        border-color: transparent;
        background-color: transparent;
        color: var(--color-primary);
      }
    }
  }
}
</style>
